import { CustomHammerConfig } from "./config/CustomHammerConfig";
import { AgentComponent } from "./components/admin/agent/agent.component";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { APP_BASE_HREF, DatePipe, registerLocaleData } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AccueilComponent } from "./components/accueil/accueil.component";
import { TestComponent } from "./components/test/test.component";
import { HeaderComponent } from "./components/include/header/header.component";
import { MenueComponent } from "./components/include/menue/menue.component";
import { FooterComponent } from "./components/include/footer/footer.component";
import { TitleComponent } from "./components/include/title/title.component";
import { LoginComponent } from "./components/login/login.component";
import { NewcommandeComponent } from "./components/commandes/newcommande/newcommande.component";
import { ListcommandeComponent } from "./components/commandes/listcommande/listcommande.component";

import {
  SpinnerModule,
  MessagesModule,
  ChartModule,
  FileUploadModule,
  RadioButtonModule,
  CheckboxModule,
  FieldsetModule,
  DropdownModule,
  CalendarModule,
  InputTextareaModule,
  TabViewModule,
  InputTextModule,
  DataTableModule,
  ButtonModule,
  DialogModule,
  ConfirmDialogModule,
  ConfirmationService,
  GrowlModule,
  /* StepsModule,*/
  InputSwitchModule,
  PaginatorModule,
  PickListModule,
  BlockUIModule,
  PasswordModule,
  OverlayPanelModule,
  AutoCompleteModule,
  LightboxModule,
  TooltipModule,
  CarouselModule,
  MultiSelectModule,
  TreeTableModule,
  TreeNode,
  DataListModule,
  MessageModule,
  ScrollPanelModule,
  CardModule,
  PanelModule,
  SplitButtonModule,
  PanelMenuModule,
  MenuModule,
  ToggleButtonModule,
  CaptchaModule,
} from "primeng/primeng";
import { TemplatesComponent } from "./components/templates/templates.component";
import { ValidationComponent } from "./components/commandes/validation/validation.component";
import { ImageComponent } from "./components/image/image.component";
import { NgxGalleryModule } from "ngx-gallery";
import { ProfilComponent } from "./components/admin/profil/profil.component";
import { ChargementObjectifComponent } from "./components/admin/chargement-objectif/chargement-objectif.component";
import { ChargementDgRevendeurComponent } from "./components/admin/chargement-dg-revendeur/chargement-dg-revendeur.component";
import { ViewcommandeComponent } from "./components/commandes/viewcommande/viewcommande.component";

import { VenteComponent } from "./components/reporting/vente/vente.component";
import { CommadeComponent } from "./components/reporting/commade/commade.component";
import { CommissionComponent } from "./components/reporting/commission/commission.component";
import { VenteGlobalComponent } from "./components/reporting/vente/vente-global/vente-global.component";
import { VenteWalletComponent } from "./components/reporting/vente/vente-wallet/vente-wallet.component";
import { VenteOmyComponent } from "./components/reporting/vente/vente-omy/vente-omy.component";
import { VenteNafamaComponent } from "./components/reporting/vente/vente-nafama/vente-nafama.component";
import { VenteCarteComponent } from "./components/reporting/vente/vente-carte/vente-carte.component";
import { CommandeCarteComponent } from "./components/reporting/commande/commande-carte/commande-carte.component";
import { CommandeOmyComponent } from "./components/reporting/commande/commande-omy/commande-omy.component";
import { CommandeWalletComponent } from "./components/reporting/commande/commande-wallet/commande-wallet.component";
import { CommandeNafamaComponent } from "./components/reporting/commande/commande-nafama/commande-nafama.component";
import { CommandeGlobalComponent } from "./components/reporting/commande/commande-global/commande-global.component";
import { CashinCashoutComponent } from "./components/reporting/omy/cashin-cashout/cashin-cashout.component";
import { CellinComponent } from "./components/reporting/marge/cellin/cellin.component";
import { CelloutComponent } from "./components/reporting/marge/cellout/cellout.component";
import { MargeArriereComponent } from "./components/reporting/marge/marge-arriere/marge-arriere.component";
import { TableaubordComponent } from "./components/reporting/tableaubord/tableaubord.component";
import { CopdvComponent } from "./components/reporting/copdv/copdv.component";
import { CommandeProduitComponent } from "./components/reporting/commande/commande-produit/commande-produit.component";
import localFr from "@angular/common/locales/fr";
import { CommandePipe } from "./pipes/commande.pipe";
import { ModificationObjectifComponent } from "./components/admin/modification-objectif/modification-objectif.component";
import { OperationwalletComponent } from "./components/operation/operationwallet/operationwallet.component";
import { AideComponent } from "./components/admin/aide/aide.component";
import { CguComponent } from "./components/cgu/cgu.component";
// import { DistriValidateCommandeComponent } from './components/distri/distri-validate-commande/distri-validate-commande.component';
import { InputImageComponent } from "../app/include/commande/input.image.component";
import { MessageService } from "primeng-lts/api";
import { DistriListCommandeComponent } from "./components/distri/distri-list-commande/distri-list-commande.component";
import { VenteApiService } from "./provider/stock/VenteApi.service";
import { FactureUpdateService } from "./provider/priseCommande/FactureUpdate.service";
import { DistriValidateCommandeComponent } from "./components/distri/distri-validate-commande/distri-validate-commande.component";
import { BanqueService } from "./provider/admin/banque.service";
import { MagasinService } from "./provider/stock/magasin.service";
import { PerformanceComponent } from "./components/reporting/performance/performance.component";
import { ReportingService } from "./components/reporting/performance/reporting.service";
import { CommissionsComponent2 } from "./components/reporting/performance/commissions.component";

registerLocaleData(localFr);

@NgModule({
  declarations: [
    AppComponent,
    AccueilComponent,
    TestComponent,
    HeaderComponent,
    MenueComponent,
    FooterComponent,
    TitleComponent,
    LoginComponent,
    NewcommandeComponent,
    ListcommandeComponent,
    TemplatesComponent,
    ValidationComponent,
    AgentComponent,
    ImageComponent,
    ProfilComponent,
    ChargementObjectifComponent,
    ChargementDgRevendeurComponent,
    ViewcommandeComponent,

    PerformanceComponent,
    CommissionsComponent2,
    VenteComponent,
    CommadeComponent,
    CommissionComponent,
    VenteGlobalComponent,
    VenteWalletComponent,
    VenteOmyComponent,
    VenteNafamaComponent,
    VenteCarteComponent,
    CommandeCarteComponent,
    CommandeOmyComponent,
    CommandeWalletComponent,
    CommandeProduitComponent,
    CommandeNafamaComponent,
    CommandeGlobalComponent,
    CashinCashoutComponent,
    CellinComponent,
    CelloutComponent,
    MargeArriereComponent,
    TableaubordComponent,
    CopdvComponent,
    CommandePipe,
    ModificationObjectifComponent,
    OperationwalletComponent,
    AideComponent,
    CguComponent,
    DistriListCommandeComponent,
    DistriValidateCommandeComponent,
    InputImageComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,

    SpinnerModule,
    MessagesModule,
    ChartModule,
    FileUploadModule,
    RadioButtonModule,
    CheckboxModule,
    FieldsetModule,
    DropdownModule,
    CalendarModule,
    InputTextareaModule,
    TabViewModule,
    InputTextModule,
    DataTableModule,
    ButtonModule,
    DialogModule,
    ConfirmDialogModule,
    GrowlModule,
    InputSwitchModule,
    PaginatorModule,
    PickListModule,
    BlockUIModule,
    PasswordModule,
    OverlayPanelModule,
    AutoCompleteModule,
    LightboxModule,
    TooltipModule,
    CarouselModule,
    MultiSelectModule,
    TreeTableModule,
    DataListModule,
    MessageModule,
    ScrollPanelModule,
    CardModule,
    PanelModule,
    SplitButtonModule,
    PanelMenuModule,
    MenuModule,
    ToggleButtonModule,
    NgxGalleryModule,
    CaptchaModule,
  ],

  providers: [
    DatePipe,
    ConfirmationService,
    MessageService,
    VenteApiService,
    FactureUpdateService,
    BanqueService,
    MagasinService,
    ReportingService,
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: CustomHammerConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// ng build --prod
